<template>
  <div
    v-if="value && show"
    :class="{
      'e-circular-loading': true,
      'e-circular-loading--full-page': fullPage,
    }"
  >
    <v-progress-circular
      v-bind="$attrs"
      :indeterminate="indeterminate"
      :size="fullPage ? 50 : size"
      :color="color"
      :width="width"
    />
  </div>
</template>

<script>
import { VProgressCircular } from 'vuetify/lib'

export default {
  name: 'ECircularLoading',

  components: {
    VProgressCircular,
  },

  props: {
    value: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: 'primary',
    },
    fullPage: {
      type: Boolean,
      default: false,
    },
    indeterminate: {
      type: Boolean,
      default: true,
    },

    size: {
      type: [Number, String],
      default: undefined,
    },

    width: {
      type: [Number, String],
      default: undefined,
    },

    timeout: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      show: false,
      timer: null,
    }
  },

  watch: {
    value: {
      handler(value) {
        this.destroyTimer()

        if (value) {
          if (this.timeout > 0) {
            this.timer = setTimeout(() => (this.show = true), this.timeout)
          } else this.show = true
        }
      },
      immediate: true,
    },
  },

  beforeDestroy() {
    this.destroyTimer()
  },

  methods: {
    destroyTimer() {
      this.timer && clearTimeout(this.timer)
      this.timer = null
      this.show = false
    },
  },
}
</script>
